/**
 * all actions for the components
 *
 * Created by Tom on 29/05/18
 */

import C from '../constants'

// action to hide/show the left menu
export const setOpenLeftMenu = booleanVal => {
    return {
        type: C.SET_OPEN_LEFT_MENU,
        payload: booleanVal
    }
}

// action to hide/show the right menu
export const setOpenRightMenu = booleanVal => {
    return {
        type: C.SET_OPEN_RIGHT_MENU,
        payload: booleanVal
    }
}

// action to hide/show the congrats info box
export const setOpenCongratsInfoBox = booleanVal => {
    return {
        type: C.SET_OPEN_CONGRATS_INFO,
        payload: booleanVal
    }
}


// WEBPACK FOOTER //
// ./src/actions/componentActions.js